:host {
  display: flex;
  flex-direction: column;
}

.header {
  overflow-wrap: anywhere;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #c6c6cc;
  padding: 8px 16px;
  gap: 8px;
  cursor: pointer;
}

h6 {
  color: #1e293e;
}

.arrow {
  font-size: 24px;
}

.content {
  overflow: hidden;
  padding: $xp-ref-spacing-4;
}
